import React from "react";
import { number, shape, string } from "prop-types";
import styles from "./RegionEventsRow.module.styl";
import { toDateStringLocaleShort } from "utils";
import cx from "classnames";
import { EventStatus } from "utils/reports/Enums/EventStatus";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";

export default function RegionEventsRow({ regionEvent, index }) {
    const GREEN_LABEL_MAX_VALUE = 2;
    const RED_LABEL_MIN_VALUE = 5;

    let icon = null;
    let iconTooltipMessage = "";
    switch (regionEvent.status) {
        case EventStatus.EventWithResults:
            icon = "approval";
            iconTooltipMessage = "Мероприятие завершено, результаты загружены";
            break;
        case EventStatus.EventInProgress:
            icon = "progress";
            iconTooltipMessage = "Мероприятие в процессе проведения";
            break;
        case EventStatus.FutureEvent:
            icon = "event";
            iconTooltipMessage = "Мероприятие запланировано";
            break;
        case EventStatus.EventWithoutResults:
            icon = "attention";
            iconTooltipMessage = "Мероприятие завершено, результаты не загружены";
            break;
        default:
            break;
    }

    return (
        <div className={cx(styles.row, index % 2 ? styles.evenBackground : styles.oddBackground)}>
            <div>
                <IconTooltip icon={icon} trigger="hover">
                    <div>{iconTooltipMessage}</div>
                </IconTooltip>
            </div>
            <div>{regionEvent.kpNumber}</div>
            <div>{regionEvent.name}</div>
            <div>{regionEvent.federationName}</div>
            <div>
                {toDateStringLocaleShort(regionEvent.startDate)} -{" "}
                {toDateStringLocaleShort(regionEvent.endDate)}
            </div>
            <div className={styles.participantsCount}>
                {regionEvent.participantsData.participantsCount}
            </div>
            <div className={styles.participantsWithResults}>
                {regionEvent.participantsData.participantsWithResult}
            </div>
            <div>
                {regionEvent.daysOdds !== null && (
                    <div
                        className={cx(
                            styles.dayBlock,
                            regionEvent.daysOdds <= GREEN_LABEL_MAX_VALUE
                                ? styles.greenLabel
                                : regionEvent.daysOdds >= RED_LABEL_MIN_VALUE
                                ? styles.redLabel
                                : styles.yellowLabel,
                        )}
                    >
                        ДНЕЙ: {regionEvent.daysOdds}
                    </div>
                )}
            </div>
        </div>
    );
}

RegionEventsRow.propTypes = {
    regionEvent: shape({
        id: number,
        name: string,
        sportTypeName: string,
        status: string,
        federationName: string,
        startDate: string,
        endDate: string,
        participantsData: shape({
            participantsCount: number,
            participantsWithResult: number,
        }),
        kpNumber: string,
        daysOdds: number,
    }),
    index: number,
};
